import React, { Component } from 'react';
import AmazonQualtrics from '../../assets/landing/amazon-preview-white.png';

import '../../static/register/AmazonReadyToBegin.css';
import DeviceHelper from '../../functions/device';

export default class GlobalHeader extends Component {
	render() {

		return (
			<header className={`amazon landing-header z-depth-0${DeviceHelper.isMobile ? " alida-mobile-header" : ""}`}>
				<nav className="qualtrics landing-header-container-web z-depth-0 height-auto">
					<img className={`landing-header-logo noselect ${DeviceHelper.isMobile ? "width-35p" : ""}`} src={AmazonQualtrics} alt='Amazon Preview' />
				</nav>
			</header>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/global/AmazonQualtricsHeader.js